import React, { useMemo, useState } from "react";
import { Row, Col, Card, Badge, Button } from "react-bootstrap";
import {
  FaBox,
  FaMapMarkerAlt,
  FaCar,
  FaTruck,
  FaCalendarAlt,
  FaClock,
  FaPaperPlane,
  FaRulerCombined,
  FaWeightHanging,
  FaStar,
  FaStickyNote,
  FaTrashAlt,
  FaUser,
  FaTruckLoading,
  FaFileInvoice,
  FaRoute,
  FaClipboardList,
  FaPallet,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { RouteMap } from "../../RouteMap";
import { formatNumber, formatDisplayDate, maskPhoneNumbers } from "../../../utils/helpers";
import DriverDetailsModal from "./DriverDetailsModal";
import { MultiLocationMap } from "../../MultiLocationMap";
import { RiPinDistanceFill } from "react-icons/ri";
import { AlarmIcon } from "../../../assets/icons";

const BookingDetailsPage = ({
  item,
  order,
  itemReceived,
  onReceive,
  onDeliver,
  onDelete,
  onClose,
  driver,
  setSelectedId,
  setSelectedItemForMap,
  setModalData,
  setShowModal,
  deleteLoading,
  receivedLoading,
  deliverLoading,
  showReceive = false,
  showDeliver = false,
  showDelete = false,
  showDriverDetails = false,
  showBookingDetails = false,
  showChat = false,
  showCMR = false,
}) => {
  const { t } = useTranslation();
  const [showDriverModal, setShowDriverModal] = useState(false);

  console.log("dataaa", item);

  const [userType, setUserType] = useState(
    typeof window !== "undefined" ? localStorage.getItem("userType") : null,
  );

  const parseCoordinates = (coordString) => {
    if (!coordString) return null;
    try {
      const [lat, lng] = coordString
        .split(",")
        .map((coord) => parseFloat(coord.trim()));
      return [lat, lng];
    } catch (error) {
      console.error("Error parsing coordinates:", error);
      return null;
    }
  };

  const fromCoords = useMemo(
    () => parseCoordinates(item.booking_from_lat_long),
    [item.booking_from_lat_long],
  );
  const toCoords = useMemo(
    () => parseCoordinates(item.booking_to_lat_long),
    [item.booking_to_lat_long],
  );

  const getExtraServiceLabel = (service) => {
    const normalizedService = String(service?.value ?? service?.name ?? service ?? "")
      .trim()
      .toLowerCase();
    const labels = {
      loading: t("loading_service"),
      unloading: t("unloading_service"),
    };

    return labels[normalizedService] || String(service ?? "");
  };

  const getExtraServices = () => {
    const services = item.extra_service;
    if (!services) return [];

    if (Array.isArray(services)) {
      return services;
    }

    if (typeof services === "string") {
      try {
        const parsed = JSON.parse(services);
        return Array.isArray(parsed) ? parsed : [services];
      } catch {
        return services
          .split(",")
          .map((service) => service.trim())
          .filter(Boolean);
      }
    }

    return [services];
  };

  const handleSendOfferClick = () => {
    setSelectedId(item.id);
    setSelectedItemForMap(item);
    setModalData({
      booking_id: item.id,
      driver_name: "",
      phone_number: "",
      vehicle_number: "",
      vehicle_id: "",
      vehicle_type: item.vehicle_type || "",
      current_location: driver?.postal_code || "",
      price: "",
      driving_choice: "",
    });
    setShowModal(true);
  };

  // booking from data
  const pickupPlaces = item.loading_company?.map((_, index) => ({
    company: item.loading_company?.[index],
    firstName: item.loading_first_name?.[index],
    lastName: item.loading_last_name?.[index],
    street: item.loading_streat_no?.[index],
    addressAdditional: item.loading_address_additional?.[index],
    postal: item.loading_postal?.[index],
    phone: item.loading_phone?.[index],
    reference: item.loading_reffernce?.[index],
  }));

  // booking from data
  const deliveryPlaces = item.unloading_company?.map((_, index) => ({
    company: item.unloading_company?.[index],
    firstName: item.unloading_first_name?.[index],
    lastName: item.unloading_last_name?.[index],
    street: item.unloading_streat_no?.[index],
    addressAdditional: item.unloading_address_additional?.[index],
    postal: item.unloading_postal?.[index],
    phone: item.unloading_phone?.[index],
    reference: item.unloading_reffernce?.[index],
  }));

  return (
    <>
      <div className="dark-three-columns">
        {/* Section 1: Route */}
        <div className="dark-section">
          <div className="dark-section-title">
            <FaRoute />
            <span>{t("driverCard.general.route")}</span>
          </div>
  
          {/*  */}
          {/* <div className="mb-3 m-4">
            <div className="mb-3">
              <div className="d-flex align-items-center mb-2">
                <FaMapMarkerAlt className="text-danger me-2" />
                <strong>{t('driverCard.general.pickup')}:</strong>
              </div>
              
              {Array.isArray(item.booking_from) && item.booking_from.length > 0 ? (
                item.booking_from.map((addr, index) => {
                  // استخراج التاريخ والوقت لكل نقطة تحميل
                  const rawDt = item.loading_date_start
                    ? null
                    : (Array.isArray(item.loading_date_time)
                      ? item.loading_date_time[index]
                      : null) || "";
                  const spaceIdx = rawDt ? rawDt.indexOf(" ") : -1;
                  const dtDate = item.loading_date_start ||
                    item.loading_date ||
                    (spaceIdx > -1 ? rawDt.substring(0, spaceIdx) : rawDt) ||
                    "-";
                  const dtTime = item.loading_time_start ||
                    item.loading_time ||
                    (spaceIdx > -1
                      ? rawDt.substring(spaceIdx + 1).replace(" - ", " → ")
                      : "-");
                  
                  return (
                    <div key={`pickup-${index}`} className="ms-3 mb-2 p-2 rounded" style={{ background: 'var(--dark-bg-primary)', borderLeft: '3px solid #ff6b00' }}>
                      <div className=" small mb-1">
                        <span className="fw-bold dark-info-label">{t('driverCard.general.pickup')} {index + 1}:</span>
                        <span className="ms-2">{addr}</span>
                      </div>
                      <div className="d-flex align-items-center column-gap-3 flex-wrap small">
                        <span>
                          <FaCalendarAlt className="me-1" size={12} />
                          {dtDate}
                          {item.loading_date_end ? ` → ${item.loading_date_end}` : ''}
                        </span>
                        <span>
                          <FaClock className="me-1" size={12} />
                          {dtTime}
                          {item.loading_time_end ? ` → ${item.loading_time_end}` : ''}
                        </span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className=" small ms-3">
                  {t('driverCard.general.notAvailable')}
                </div>
              )}
            </div>
  
            <div className="mb-2">
              <div className="d-flex align-items-center mb-2">
                <FaMapMarkerAlt className="text-success me-2" />
                <strong>{t('driverCard.general.delivery')}:</strong>
              </div>
              
              {Array.isArray(item.booking_to) && item.booking_to.length > 0 ? (
                item.booking_to.map((addr, index) => {
                  // استخراج التاريخ والوقت لكل نقطة تنزيل
                  const rawDt = item.unloading_date_start
                    ? null
                    : (Array.isArray(item.unloading_date_time)
                      ? item.unloading_date_time[index]
                      : null) || "";
                  const spaceIdx = rawDt ? rawDt.indexOf(" ") : -1;
                  const dtDate = item.unloading_date_start ||
                    item.unloading_date ||
                    (spaceIdx > -1 ? rawDt.substring(0, spaceIdx) : rawDt) ||
                    "-";
                  const dtTime = item.unloading_time_start ||
                    item.unloading_time ||
                    (spaceIdx > -1
                      ? rawDt.substring(spaceIdx + 1).replace(" - ", " → ")
                      : "-");
                  
                  return (
                    <div key={`delivery-${index}`} className="ms-3 mb-2 p-2 rounded" style={{ background: 'var(--dark-bg-primary)', borderLeft: '3px solid #28a745' }}>
                      <div className=" small mb-1">
                        <span className="fw-bold dark-info-label">{t('driverCard.general.delivery')} {index + 1}:</span>
                        <span className="ms-2">{addr}</span>
                      </div>
                      <div className="d-flex align-items-center column-gap-3 flex-wrap small">
                        <span>
                          <FaCalendarAlt className="me-1" size={12} />
                          {dtDate}
                          {item.unloading_date_end ? ` → ${item.unloading_date_end}` : ''}
                        </span>
                        <span>
                          <FaClock className="me-1" size={12} />
                          {dtTime}
                          {item.unloading_time_end ? ` → ${item.unloading_time_end}` : ''}
                        </span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className=" small ms-3">
                  {t('driverCard.general.notAvailable')}
                </div>
              )}
            </div>
          </div> */}
          
          <div className="dark-section-body">
            {/* Map */}
            <div className="dark-map-wrapper">
              
              {fromCoords && toCoords ? (
                <RouteMap fromCoords={fromCoords} toCoords={toCoords} />
              ) : (
                <MultiLocationMap
                  fromCoords={
                    Array.isArray(item?.booking_from_lat_long)
                      ? item.booking_from_lat_long
                      : Array.isArray(item?.from_lat_long)
                      ? item.from_lat_long
                      : []
                  }
                  toCoords={
                    Array.isArray(item?.booking_to_lat_long)
                      ? item.booking_to_lat_long
                      : Array.isArray(item?.to_lat_long)
                      ? item.to_lat_long
                      : []
                  }
                  key={`map-${item?.id}-${JSON.stringify(item?.booking_from_lat_long)}-${JSON.stringify(item?.booking_to_lat_long)}`}
                />
              )}
            </div>
  
            {/* pickup & delivery */}
            <div className="dark-route-stats py-3 justify-content-between flex-wrap">
  
              <div className="d-flex align-items-center gap-2">
                <FaMapMarkerAlt className="stat-icon text-danger" style={{ fontSize: "25px" }} />
                <span className="stat-label">
                  {t("driverCard.general.pickup")}:
                </span>
              </div>
              <div className="dark-route-stat flex-row flex-wrap" style={{ borderBottom: '1px solid rgb(212 212 212 / 39%)' }}>
                {Array.isArray(item.booking_from) && item.booking_from.length > 0 ? (
                  item.booking_from.map((addr, index) => {
                    // استخراج التاريخ والوقت لكل نقطة تحميل
                    const rawDt = item.loading_date_start
                      ? null
                      : (Array.isArray(item.loading_date_time)
                        ? item.loading_date_time[index]
                        : null) || "";

                        const spaceIdx = rawDt
                      ? rawDt.indexOf(" ")
                      : -1;
                    const dtDate =
                      item.loading_date_start ||
                      item.loading_date ||
                      (spaceIdx > -1
                        ? rawDt.substring(0, spaceIdx)
                        : rawDt) ||
                      "-";
                    const dtTime =
                      item.loading_time_start ||
                      item.loading_time ||
                      (spaceIdx > -1
                        ? rawDt
                          .substring(spaceIdx + 1)
                          .replace(" - ", " → ")
                        : "-");
                    
                    return (
                      <div key={`pickup-${index}`} className="p-2 rounded">
                        <div className="text-center">
                          <span className="stat-value d-block">{addr}</span>
                          <div
                            className="p-2 d-inline-block"
                            style={{
                              backgroundColor: "inherit",
                              borderRadius: "8px",
                              // border: "1px solid rgb(212 212 212 / 39%)",
                            }}
                          >
                            <div className="d-flex align-items-center mb-1 gap-3">
                              <span
                                className="d-flex align-items-center dark-info-label small"
                                style={{ minWidth: "70px" }}
                              >
                                <FaCalendarAlt className="text-orange me-2" />{" "}
                                {t(
                                  "driverCard.general.dates",
                                  "Datum",
                                )}
                              </span>
                              <span className="text-dark fw-medium small flex-grow-1 text-start">
                                {dtDate}
                                {item.loading_date_end
                                  ? ` → ${item.loading_date_end}`
                                  : ""}
                              </span>
                            </div>
                            <div
                              className="d-flex align-items-center mt-1 pt-1 gap-3"
                              style={{
                                borderTop: "1px solid rgb(212 212 212)",
                              }}
                            >
                              <span
                                className="d-flex align-items-center dark-info-label small"
                                style={{ minWidth: "70px" }}
                              >
                                <AlarmIcon
                                  className="text-orange me-2"
                                  style={{ width: 16 }}
                                />{" "}
  
                                <span className="dark-info-label" style={{ marginLeft: "4px" }}>
                                  {t(
                                    "driverCard.general.time",
                                    "Uhrzeit",
                                  )}
                                </span>
                              </span>
                              <span className="text-dark fw-medium small flex-grow-1 text-start d-flex align-items-center">
                                {dtTime}
                                {item.loading_time_end
                                  ? ` → ${item.loading_time_end}`
                                  : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className=" small ms-3">
                    {t('driverCard.general.notAvailable')}
                  </div>
                )}
              </div>
  
              <div className="d-flex align-items-center gap-2 mt-4">
                <FaMapMarkerAlt className="stat-icon text-success" style={{ fontSize: "25px" }} />
                <span className="stat-label">
                  {t("driverCard.general.delivery")}:
                </span>
              </div>
              <div className="dark-route-stat flex-row flex-wrap">
                {Array.isArray(item.booking_to) && item.booking_to.length > 0 ? (
                  item.booking_to.map((addr, index) => {
                    // استخراج التاريخ والوقت لكل نقطة تحميل
                    const rawDt = item.unloading_date_start
                      ? null
                      : (Array.isArray(item.unloading_date_time)
                        ? item.unloading_date_time[index]
                        : null) || "";

                        const spaceIdx = rawDt
                    ? rawDt.indexOf(" ")
                    : -1;
                  const dtDate =
                    item.unloading_date_start ||
                    item.unloading_date ||
                    (spaceIdx > -1
                      ? rawDt.substring(0, spaceIdx)
                      : rawDt) ||
                    "-";
                  const dtTime =
                    item.unloading_time_start ||
                    item.unloading_time ||
                    (spaceIdx > -1
                      ? rawDt
                        .substring(spaceIdx + 1)
                        .replace(" - ", " → ")
                      : "-");
                    
                    return (
                      <div key={`delivery-${index}`} className="p-2 rounded">
                        <div className="text-center">
                          <span className="stat-value d-block">{addr}</span>
                          <div
                            className="p-2 d-inline-block"
                            style={{
                              backgroundColor: "inherit",
                              borderRadius: "8px",
                              // border: "1px solid rgb(212 212 212 / 39%)",
                            }}
                          >
                            <div className="d-flex align-items-center mb-1 gap-3">
                              <span
                                className="d-flex align-items-center dark-info-label small"
                                style={{ minWidth: "70px" }}
                              >
                                <FaCalendarAlt className="text-orange me-2" />{" "}
                                {t(
                                  "driverCard.general.dates",
                                  "Datum",
                                )}
                              </span>
                              <span className="text-dark fw-medium small flex-grow-1 text-start">
                                {dtDate}
                                {item.unloading_date_end
                                  ? ` → ${item.unloading_date_end}`
                                  : ""}
                              </span>
                            </div>
                            <div
                              className="d-flex align-items-center mt-1 pt-1 gap-3"
                              style={{
                                borderTop: "1px solid rgb(212 212 212)",
                              }}
                            >
                              <span
                                className="d-flex align-items-center dark-info-label small"
                                style={{ minWidth: "70px" }}
                              >
                                <AlarmIcon
                                  className="text-orange me-2"
                                  style={{ width: 16 }}
                                />{" "}
  
                                <span className="dark-info-label" style={{ marginLeft: "4px" }}>
                                  {t(
                                    "driverCard.general.time",
                                    "Uhrzeit",
                                  )}
                                </span>
                              </span>
                              <span className="text-dark fw-medium small flex-grow-1 text-start d-flex align-items-center">
                                {dtTime}
                                {item.unloading_time_end
                                  ? ` → ${item.unloading_time_end}`
                                  : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className=" small ms-3">
                    {t('driverCard.general.notAvailable')}
                  </div>
                )}
              </div>
  
            </div>
  
            {/* Route Stats */}
            <div className="dark-route-stats justify-content-between">
  
              <div className="dark-route-stat gap-2 flex-row">
                <RiPinDistanceFill className="stat-icon" style={{ fontSize: "25px" }} />
                <div className="text-center">
                  <span className="stat-value d-block">{(item.distance || "0 km").replace("km", " km")}</span>
                  <span className="stat-label">
                    {t("driverCard.general.distance")}
                  </span>
                </div>
              </div>
  
              <div className="dark-route-stat gap-2 flex-row">
                <FaClock className="stat-icon" style={{ fontSize: "25px" }} />
                <div className="text-center">
                  <span className="stat-value d-block">{item.total_duration || "-"}</span>
                  <span className="stat-label">
                    {t("driverCard.general.duration")}
                  </span>
                </div>
              </div>
  
            </div>
          </div>
        </div>
  
        {/* Section 2: Vehicle & Actions */}
        <div className="dark-section">
          <div className="dark-section-title">
            <FaTruck />
            <span>{t("driverCard.orderDetails.vehicleAndActions")}</span>
          </div>
          <div className="dark-section-body">
  
            {/* CTA Button */}
            {showBookingDetails && (
                <>
                  {pickupPlaces?.length > 0 ? (
                    <div className="mb-2">
                      <h6 className="fw-bold text-secondary mb-3">
                        {t("driverCard.general.pickup")}
                      </h6>

                      {pickupPlaces.map((place, idx) => (
                        <div
                          key={idx}
                          className="mb-3 p-3 border rounded bg-light"
                        >
                          <div className="fw-bold text-orange mb-2 small">
                            {t("driverCard.general.pickup")} ({idx + 1})
                          </div>
                          <div className="dark-info-label small">
                            <strong>
                              {t("clientDetails.pickup.company")}:
                            </strong>{" "}
                            {place.company ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>{t("clientDetails.pickup.name")}:</strong>{" "}
                            {place.firstName ||
                              t("driverCard.general.notAvailable")}{" "}
                            {place.lastName ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>
                              {t("clientDetails.pickup.address")}:
                            </strong>{" "}
                            {place.street ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>
                              {t("driverInfo.postalCodeCity")}:
                            </strong>{" "}
                            {place.postal ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>
                              {t("clientDetails.pickup.additional_address")}:
                            </strong>{" "}
                            {place.addressAdditional ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>{t("clientDetails.pickup.phone")}:</strong>{" "}
                            {place.phone ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>
                              {t("clientDetails.pickup.reference")}:
                            </strong>{" "}
                            {place.reference ||
                              t("driverCard.general.notAvailable")}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="dark-info-label">
                      {t("driverCard.general.noShipmentData")}
                    </p>
                  )}

                  {deliveryPlaces?.length > 0 ? (
                    <div className="mb-2">
                      <h6 className="fw-bold text-secondary mb-3">
                        {t("driverCard.general.delivery")}
                      </h6>

                      {deliveryPlaces.map((place, idx) => (
                        <div
                          key={idx}
                          className="mb-3 p-3 border rounded bg-light"
                        >
                          <div className="fw-bold text-orange mb-2 small">
                            {t("driverCard.general.delivery")} ({idx + 1})
                          </div>
                          <div className="dark-info-label small">
                            <strong>
                              {t("clientDetails.delivery.company")}:
                            </strong>{" "}
                            {place.company ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>{t("clientDetails.delivery.name")}:</strong>{" "}
                            {place.firstName ||
                              t("driverCard.general.notAvailable")}{" "}
                            {place.lastName ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>
                              {t("clientDetails.delivery.address")}:
                            </strong>{" "}
                            {place.street ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>
                              {t("driverInfo.postalCodeCity")}:
                            </strong>{" "}
                            {place.postal ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>
                              {t("clientDetails.delivery.additional_address")}:
                            </strong>{" "}
                            {place.addressAdditional ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>
                              {t("clientDetails.delivery.phone")}:
                            </strong>{" "}
                            {place.phone ||
                              t("driverCard.general.notAvailable")}
                          </div>

                          <div className="dark-info-label small">
                            <strong>
                              {t("clientDetails.delivery.reference")}:
                            </strong>{" "}
                            {place.reference ||
                              t("driverCard.general.notAvailable")}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="dark-info-label">
                      {t("driverCard.general.noShipmentData")}
                    </p>
                  )}
                </>
              )}

            {/* زر الإجراء */}
            <div className="mt-5">
              {showDriverDetails && order && (
                <div className="my-3">
                  <Button
                    className="w-100 py-2 fw-bold"
                    variant="info"
                    onClick={() => setShowDriverModal(true)}
                  >
                    <FaUser className="me-2" />
                    {t("driverCard.buttons.viewDriverDetails")}
                  </Button>
                </div>
              )}

              {order?.stages && order.stages.length > 0 ? (
                order.stages.map((stage) => (
                  <div
                    key={stage.stage_number}
                    className="mb-4 p-3 border rounded bg-light"
                  >
                    <h6 className="fw-bold text-secondary mb-3">
                      {t("driverRequest.general.stage")} {stage.stage_number}
                      <Badge bg="info" className="ms-2">
                        {stage.from_location} → {stage.to_location}
                      </Badge>
                    </h6>

                    {/* (Receive) */}
                    <div className="d-grid gap-2 mb-2">
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={() => onReceive(order, stage.stage_number)}
                        disabled={!!stage.received_date}
                      >
                        <FaTruckLoading className="me-2" />
                        {t("driverRequest.buttons.receive")}{" "}
                        {stage.stage_number}
                        {stage.received_date &&
                          ` - ${formatDisplayDate(stage.received_date)}`}
                      </Button>
                    </div>

                    {/* (Deliver) */}
                    <div className="d-grid gap-2">
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => onDeliver(order, stage.stage_number)}
                        disabled={
                          !stage.received_date || !!stage.completed_date
                        }
                      >
                        <FaTruckLoading className="me-2" />
                        {t("driverRequest.buttons.deliver")}{" "}
                        {stage.stage_number}
                        {stage.completed_date &&
                          ` - ${formatDisplayDate(stage.completed_date)}`}
                      </Button>
                    </div>
                  </div>
                ))
              ) : null}

              {showCMR &&
                item.bill_path &&
                item.bill_path.map((billUrl, index) => (
                  <>
                    <div className="my-3">
                      <Button
                        key={index}
                        className="bg-primary w-100 py-2 fw-bold"
                        onClick={() => window.open(billUrl, "_blank")}
                      >
                        <FaFileInvoice className="me-2" />
                        CMR {index + 1}
                      </Button>
                    </div>
                  </>
                ))}

              {showDelete && onDelete && (
                <Button
                  className="w-100 py-2 fw-bold mt-2"
                  variant="danger"
                  onClick={() => onDelete(order)}
                  disabled={deleteLoading}
                >
                  <FaTrashAlt className="me-2" />
                  {deleteLoading
                    ? t("driverOffer.buttons.deleting")
                    : t("driverOffer.buttons.delete")}
                </Button>
              )}

              {onClose && (
                <Button
                  className="w-100 py-2 fw-bold mt-2 d-md-block d-none"
                  variant="secondary"
                  onClick={onClose}
                >
                  {t("driverCard.buttons.close")}
                </Button>
              )}

              {/* السعر المقترح */}
              {userType === "driver" && (
                <>
                  {(order?.price || item?.discounted_price) && (
                    <div className="text-center mt-2">
                      <small className="dark-info-labe">
                        {t("driverCard.priceDetails.priceSuggestion")}:
                      </small>
                      <div className="fw-bold text-success fs-5">
                        {order?.price || item?.discounted_price} EUR (Netto)
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
  
        {/* Section 3: Shipment Details */}
        <div className="dark-section">
          <div className="dark-section-title">
            <FaClipboardList />
            <span>{t("driverCard.orderDetails.shipmentDetails")}</span>
          </div>
          <div className="dark-section-body">
  
            {/* بيانات الشحنة */}
            {item.shipment_data?.length > 0 ? (
              <div className="mb-3">
                <div className="mb-4">
                  <h6 className="fw-bold text-secondary mb-3">
                    {t("driverCard.general.items")}
                  </h6>
                  <div className="d-flex align-items-center mb-3 p-2 bg-light rounded">
                    <FaTruck className="text-primary me-2" />
                    <div>
                      <div className="fw-bold">
                        {item.vehicle_type ||
                          t("driverCard.general.notAvailable")}

                          {Number(item.vehicle_id) === 4 &&
                          ` (${item.crane === "yes"
                              ? t("driverCard.general.withCrane", "Mit Hebebühne")
                              : t("driverCard.general.withoutCrane", "Ohne Hebebühne")})`}
                      </div>
                      <small className="dark-info-label">
                        {t("driverCard.orderDetails.vehicleType")}
                      </small>
                    </div>
                  </div>
                </div>
                <h6 className="fw-bold text-secondary mb-3">
                  {t("driverCard.orderDetails.shipment")} (
                  {item.shipment_data.length})
                </h6>

                {item.shipment_data.map((s, idx) => (
                  <div
                    key={idx}
                    className="mb-3 p-3 border rounded bg-light"
                  >
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <Badge bg="orange">#{idx + 1}</Badge>
                      <span className="fw-bold">
                        {s.quantity || 1} ×{" "}
                        {t(s.shipment_data) ||
                          t("driverCard.general.notAvailable")}
                      </span>
                    </div>
                    {s.shipment_data != "dokument" && (               
                      <div className="row small dark-info-label">
                        <div className="col-12 mb-1">
                          <FaRulerCombined className="me-1" />
                          {s.length || "0"} × {s.width || "0"} ×{" "}
                          {s.height || "0"} cm
                        </div>
                        <div className="col-12">
                          <FaWeightHanging className="me-1" />
                          <strong>
                            {t("driverCard.transportDetails.weight")}:
                          </strong>{" "}
                          {s.weight || "0"} kg
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <p className="dark-info-label">
                {t("driverCard.general.noShipmentData")}
              </p>
            )}

            {/* الوزن الإجمالي */}
            <div className="border-top pt-3">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-bold text-dark">
                  {t("driverCard.transportDetails.totalWeight")}:
                </span>
                <Badge bg="success" className="fs-6">
                  {formatNumber(item.total_weight)} kg
                </Badge>
              </div>
            </div>

            {/* الخدمات الإضافية */}
            {getExtraServices().length > 0 && (
              <div className="mt-3">
                <h6 className="fw-bold text-secondary mb-2">
                  <FaStar className="me-1 text-warning" />
                  {t("driverCard.orderDetails.extraService")}
                </h6>
                <div className="d-flex flex-wrap gap-1">
                  {getExtraServices().map((service, idx) => (
                    <Badge key={idx} bg="warning" text="dark">
                      {getExtraServiceLabel(service)}
                    </Badge>
                  ))}
                </div>
              </div>
            )}

            {/* الملاحظات */}
            {(item.notizen || item.message) && (
              <div className="mt-3">
                <h6 className="fw-bold text-secondary mb-2">
                  <FaStickyNote className="me-1 text-info" />
                  {t("driverCard.orderDetails.notes")}
                </h6>
                {item.notizen && (
                  <div className="mb-2">
                    <small className="text-muted">
                      {t("driverCard.orderDetails.notes")}:
                    </small>
                    <p className="mb-1 p-2 bg-light rounded">
                      {maskPhoneNumbers(item.notizen)}
                    </p>
                  </div>
                )}
                {item.message && (
                  <div>
                    <small className="text-muted">
                      {t("driverCard.orderDetails.additionalInformation")}:
                    </small>
                    <p className="mb-0 p-2 bg-light rounded">
                      {maskPhoneNumbers(item.message)}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <DriverDetailsModal
        show={showDriverModal}
        onHide={() => setShowDriverModal(false)}
        driverData={order}
        type="booking"
      />
    </>
  );
};

export default BookingDetailsPage;
